module.exports = __webpack_public_path__ + "static/img/list.75456bc6.svg";